import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getPrivacyPolicyIsAccepted, PrivacyPolicyIsAcceptedValue, setPrivacyPolicyIsAccepted } from "../../helper/storage";

interface PrivacyPolicyState {
  privacyPolicyDialogVisible: boolean
};

const initialState: PrivacyPolicyState = {
  
  privacyPolicyDialogVisible: false,
};

export const privacyPolicySlice = createSlice({
  name: 'privacyPolicy',
  initialState,
  reducers: {
    showPrivacyPolicyDialogBeforeMeasurement: (state) => {

      const privacyPolicyIsAccepted = getPrivacyPolicyIsAccepted();
      const show = privacyPolicyIsAccepted === null || privacyPolicyIsAccepted !== "True";

      return {
        ...state,
        privacyPolicyDialogVisible: show,
      }
    },
    closePrivacyPolicyDialog: (state, action: PayloadAction<PrivacyPolicyIsAcceptedValue>) => {
      setPrivacyPolicyIsAccepted(action.payload);
      return {
        ...state,
        privacyPolicyDialogVisible: false,
      }
    }
  },
});

export const { showPrivacyPolicyDialogBeforeMeasurement, closePrivacyPolicyDialog } = privacyPolicySlice.actions;

export default privacyPolicySlice;